import { render } from "./AdminView25Liquidation.vue?vue&type=template&id=73f211e9"
import script from "./AdminView25Liquidation.vue?vue&type=script&lang=js"
export * from "./AdminView25Liquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__